import * as _4 from 'lodash4';
import { ColorUtility } from 'utility-ts-type';
import { APCourse } from '../builders/ap_course_builder';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../builders/ap_planned_course_builder';
import { APSectionType } from '../builders/ap_section_type_builder';
import { PlannedCourse } from '../builders/planned_course_builder';
import { CourseStatusBadgeEvaluator } from '../strategies/ap_term_course_status_group_strategy';
import { CourseConflictEnum } from '../types/course_conflict_enum';
import { APSectionTypeServant } from './ap_section_type_servant';
export class APPlannedCourseServant {
  static hasRequisiteProblem(plannedCourse: APPlannedCourse): boolean {
    const requisiteProblemKeys = ['prereq_outoforder', 'prereq_miss', 'coreq_outoforder', 'coreq_miss'];
    const reqOrderMissProblem = _4.some(requisiteProblemKeys, (key) => plannedCourse[key].length > 0);
    const preReqNotSatisfied = _4.some([`is_prereq_course_satisfied`, `is_prereq_grade_satisfied`], (key) => {
      return !_4.get(plannedCourse, key, true);
    });
    return reqOrderMissProblem || preReqNotSatisfied;
  }
  static hasCoursesOfferedProblem(plannedCourse: APPlannedCourse): boolean {
    return !_4.get(plannedCourse, 'is_course_offered', true);
  }

  static statusBadge(plannedCourse: { status: PlannedCourse['status'] }) {
    return CourseStatusBadgeEvaluator.evaluate(plannedCourse.status, 'planned');
  }

  static multiSectionLabels(plannedCourse: APPlannedCourse & IAPPlannedCourseMeta): string {
    const backgroundClassOfSection = ColorUtility.mapWordToTertiaryColor(
      _4.get(plannedCourse, '_course.nk', ''),
      'bdr'
    );
    const sectionParts = _4.groupBy(plannedCourse._section_types, 'name');
    const prefixToMultiSectionLabels = `${_4.size(sectionParts)} parts: `;
    return _4.reduce(
      _4.keys(sectionParts),
      (labels: any, sectionPartName: string) => {
        return labels + APSectionTypeServant.writeMultiSectionTypeLabel(sectionPartName, backgroundClassOfSection);
      },
      prefixToMultiSectionLabels
    );
  }

  static buildPlannedCourseHoverTemplate(plannedCourse: APPlannedCourse & IAPPlannedCourseMeta, course: APCourse) {
    let hoverTemplate = ``;
    if (!_4.isEmpty(plannedCourse) && plannedCourse._hasRequisiteProblem) {
      const conflictTemplate = _4.reduce(
        ['prereq_outoforder', 'prereq_miss', 'coreq_outoforder', 'coreq_miss'],
        (template: string, key: string) => {
          const upperCaseKey = _4.toUpper(key);
          const courseTitleTemplate = _4.reduce(
            plannedCourse[`_${key}`],
            (tpl: string, conflictCourse: APCourse) => `${tpl}<li class='text-bold'>${conflictCourse._title}</li>`,
            ``
          );
          return !_4.isEmpty(courseTitleTemplate)
            ? `${template}<p class="mtm clr-black-txt">${CourseConflictEnum[upperCaseKey].template}</p><ul class='no-dot clr-black-txt'>${courseTitleTemplate}</ul>`
            : template;
        },
        ''
      );
      const gradeConflictTemplate = !plannedCourse.is_prereq_grade_satisfied
        ? `
      <p class="text clr-black-txt">
        One (or more) of these prerequisites has not met grade requirements. Click the course name for more details.
      </p>`
        : ``;

      hoverTemplate += `<strong class='clr-red_30-txt clearfix text-bold'> Needs Attention </strong>
        ${gradeConflictTemplate}
        <span>${conflictTemplate}</span>`;
    }

    if (!_4.isEmpty(plannedCourse) && plannedCourse._hasMultiSections) {
      hoverTemplate += plannedCourse._multiSectionLabels;
    }
    return hoverTemplate;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_planned_course_servant.ts